import { useState } from "react";
import VideoShowcase from "@/components/VideoShowcase";
import LoopVisual from "@/components/LoopVisual";
import GetAppDialog from "@/components/GetAppDialog";
import { MEDIA } from "@/lib/api";

export default function Hero({ onEnquire }) {
  const [getApp, setGetApp] = useState(false);
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="relative pt-16 pb-24 px-6 border-b border-[#00F0FF]/10 overflow-hidden" data-testid="hero-section">
      <div className="max-w-6xl mx-auto">
        <h1 className="font-disp text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-[1] mb-8 text-white max-w-4xl" data-testid="hero-headline">
          <span className="ln"><span>AHEAD OF MARKET With</span></span>
          <span className="ln"><span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-[#CFF6FA] to-[#7FE3F0]">CUTTING Edge AIoT</span></span>
          <span className="ln"><span>INTELLIGENT Automation</span></span>
        </h1>
        <p className="d1-fade-sub text-lg sm:text-xl text-white/80 max-w-2xl font-light mb-10 leading-relaxed" data-testid="hero-subline">
          Next-generation smart townships, bespoke luxury residences, commercial suites and native mobile AIoT hardware built for India.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center pt-4">
          <div className="lg:col-span-8">
            <VideoShowcase startIndex={0} label="Autoplay Ad Film" hint="Tap for Sound" testid="hero-video" />
          </div>

          <div className="lg:col-span-4 flex flex-col gap-4">
            <div className="relative rounded-xl overflow-hidden border border-[#FF1E8C]/15 aspect-[16/9]" data-testid="hero-model-visual">
              <LoopVisual {...MEDIA.ambassadorHero} alt="LuxeRay brand ambassador in a neon smart home" testid="hero-model-loop" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#061536]/90 via-transparent to-transparent" />
              <span className="absolute bottom-3 left-3 font-mono-lbl text-[10px] text-[#FF1E8C] uppercase tracking-wider bg-[#061536]/80 px-2.5 py-1 rounded">LuxeRay Ambassador</span>
            </div>
            <div className="p-6 rounded-xl bg-[#061536]/80 border border-white/10 d1-fade-cta">
              <span className="font-mono-lbl text-[11px] text-[#FF1E8C] uppercase tracking-wider block mb-1">Native App Ready</span>
              <h2 className="text-xl font-bold mb-2">LuxeRay Control Hub</h2>
              <p className="text-white/70 text-sm mb-4">Command every zone, scene and sensor in milliseconds from iOS or Android.</p>
              <button
                onClick={() => setGetApp(true)}
                className="block text-center w-full bg-[#FF2E2E] hover:bg-[#E01F1F] text-white py-3 rounded-lg font-mono-lbl text-xs uppercase tracking-wider font-bold shadow-lg shadow-black/30 transition-colors"
                data-testid="hero-download-app-btn"
              >
                Download LuxeRay App
              </button>
              <GetAppDialog open={getApp} onOpenChange={setGetApp} />
            </div>
            <div className="p-6 rounded-xl bg-[#061536]/40 border border-[#00F0FF]/20 flex items-center justify-between">
              <div>
                <span className="font-mono-lbl text-[11px] text-[#00F0FF] uppercase block">Coverage</span>
                <span className="text-lg font-bold" data-testid="hero-coverage">Pan India Deployment</span>
              </div>
              <button onClick={() => scrollTo("enquiry")} className="text-xs font-mono-lbl text-white/80 hover:text-[#00F0FF] uppercase underline" data-testid="hero-enquire-link">
                Enquire Now →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
